import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { memo } from "react";

import ProgressBar from "@/components/ProgressBar";
import Text from "@/components/Text";
import { api } from "@/utils/api";
import { YoutubeQuotaResource } from "@/types/resources";

const Box = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  padding: 16px 24px;
  margin: 16px 0;
`;

const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledText = styled(Text)`
  font-size: 11px;
`;

const StyledProgressBar = styled(ProgressBar)`
  height: 8px;
  margin: 12px 0;
`;

const OptimisationYoutubeQuota = memo(() => {
  const { data: quotas } = useQuery<YoutubeQuotaResource>(
    ["youtube_quotas"],
    () => api.get<never, YoutubeQuotaResource>("/v1/youtube-quota-usage"),
    {
      staleTime: 60 * 1000,
    }
  );

  const renderQuotaType = () => {
    if (!!!quotas) return "primary";

    if ((quotas.quotaUsed / quotas.quotaLimit) * 100 < 60) return "success";

    if ((quotas.quotaUsed / quotas.quotaLimit) * 100 < 80) return "progress";

    return "failed";
  };

  return (
    <>
      {!!quotas && (
        <Box>
          <InfoWrapper>
            <StyledText $type="smallBold">Youtube tests count</StyledText>
            <StyledText $type="smallBold">
              {quotas.testsCreated} / {quotas.testsLimit}
            </StyledText>
          </InfoWrapper>
          <StyledProgressBar
            progress={
              !!quotas.quotaUsed
                ? (quotas.quotaUsed / quotas.quotaLimit) * 100
                : 0
            }
            color={renderQuotaType()}
            type="big"
          />
          <InfoWrapper>
            <StyledText $type="smallBold">Youtube quota usage</StyledText>
            <StyledText $type="smallBold">
              {quotas.quotaUsed} /{" "}
              {quotas.quotaLimit
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
            </StyledText>
          </InfoWrapper>
        </Box>
      )}
    </>
  );
});

export default OptimisationYoutubeQuota;
